var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "validate-contract px-4 desktop:px-0" },
    [
      _c("div", { staticClass: "text-lg font-bold text-primary-dark-500" }, [
        _vm._v("\n        " + _vm._s(_vm.$t("contract.form-title")) + "\n    ")
      ]),
      _vm._v(" "),
      _vm.showDropinShadow
        ? _c("div", {
            staticClass: "fixed z-20 top-0 left-0 w-screen h-screen",
            staticStyle: { "background-color": "rgba(0,0,0,0.7)" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex my-4 space-y-4 desktop:space-x-4 desktop:space-y-0 flex-col desktop:flex-row"
        },
        [
          _c(
            "form",
            {
              ref: "form",
              staticClass:
                "registration-form border border-primary-500 rounded-md shadow-md p-2",
              attrs: { action: _vm.action, method: "POST" },
              on: {
                submit: function($event) {
                  _vm.onSubmit($event)
                }
              }
            },
            [
              _c("input", {
                attrs: { type: "hidden", name: "_token" },
                domProps: { value: _vm.csrkToken }
              }),
              _vm._v(" "),
              _c(
                "md-card",
                {
                  staticClass: "flex flex-col",
                  class: {
                    individual: !!_vm.user && !!_vm.user.isUserIndividual
                  }
                },
                [
                  _c(
                    "md-card-content",
                    { staticClass: "col shrink-0 overflow-x-hidden flex-grow" },
                    [
                      _vm.isEntityProfessional
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "text-lg font-bold text-primary-dark-500"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("contract.general-infos")) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isEntityProfessional
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "text-lg font-bold text-primary-dark-500"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("contract.personal-infos")) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col desktop:flex-row flex-wrap"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row w-full shrink-0 overflow-x-hidden",
                              class: {
                                "desktop:w-1/2": _vm.isEntityProfessional
                              }
                            },
                            [
                              _c(
                                "md-field",
                                {
                                  class: {
                                    "md-invalid": !!_vm.errors["user_firstname"]
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("registration.firstname"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "user_firstname",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null,
                                      autofocus: ""
                                    },
                                    model: {
                                      value: _vm.fData.user_firstname,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.fData,
                                          "user_firstname",
                                          $$v
                                        )
                                      },
                                      expression: "fData.user_firstname"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors["user_firstname"]
                                          ? _vm.errors["user_firstname"][0]
                                          : ""
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row w-full shrink-0 overflow-x-hidden",
                              class: {
                                "desktop:w-1/2": _vm.isEntityProfessional
                              }
                            },
                            [
                              _c(
                                "md-field",
                                {
                                  class: {
                                    "md-invalid": !!_vm.errors["user_lastname"]
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("registration.lastname"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "user_lastname",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null,
                                      autofocus: ""
                                    },
                                    model: {
                                      value: _vm.fData.user_lastname,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.fData,
                                          "user_lastname",
                                          $$v
                                        )
                                      },
                                      expression: "fData.user_lastname"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors["user_lastname"]
                                          ? _vm.errors["user_lastname"][0]
                                          : ""
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isEntityProfessional
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "form-row w-full shrink-0 overflow-x-hidden"
                                },
                                [
                                  _c(
                                    "md-field",
                                    {
                                      class: {
                                        "md-invalid": !!_vm.errors["quality"]
                                      }
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(_vm.$t("contract.quality"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: {
                                          name: "quality",
                                          disabled: _vm.submitting
                                            ? "disabled"
                                            : null,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.fData.quality,
                                          callback: function($$v) {
                                            _vm.$set(_vm.fData, "quality", $$v)
                                          },
                                          expression: "fData.quality"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "md-error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors["quality"]
                                              ? _vm.errors["quality"][0]
                                              : ""
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("EntityTypeSelector", {
                                    attrs: {
                                      "field-class": {
                                        "md-invalid": !!_vm.errors[
                                          "entity_type_id"
                                        ]
                                      },
                                      errors: _vm.errors["entity_type_id"],
                                      name: "entity_type_id",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null,
                                      model: _vm.fData.entity_type_id,
                                      "entity-type-id": parseInt(
                                        _vm.fData.entity_type_id
                                      )
                                    },
                                    on: {
                                      "on-change": function(value) {
                                        return (_vm.fData.entity_type_id = value)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEntityProfessional
                            ? _c(
                                "div",
                                { staticClass: "form-row w-full" },
                                [
                                  _vm.fData.entity_country_id == 1
                                    ? _c(
                                        "md-autocomplete",
                                        {
                                          ref: "sirenAutocomplete",
                                          attrs: {
                                            "md-options": _vm.sirenNameResults,
                                            required: ""
                                          },
                                          on: {
                                            "md-changed": _vm.onSirenNameInput,
                                            "md-selected": _vm.onSirenSelected
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "md-autocomplete-item",
                                              fn: function(ref) {
                                                var item = ref.item
                                                return [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(item.siret) +
                                                      " - " +
                                                      _vm._s(
                                                        item.uniteLegale
                                                          .denominationUniteLegale
                                                      ) +
                                                      " - " +
                                                      _vm._s(
                                                        item
                                                          .adresseEtablissement
                                                          .codePostalEtablissement
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        item
                                                          .adresseEtablissement
                                                          .libelleCommuneEtablissement
                                                      ) +
                                                      "\n                                "
                                                  )
                                                ]
                                              }
                                            }
                                          ]),
                                          model: {
                                            value: _vm.fData.entity_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.fData,
                                                "entity_name",
                                                $$v
                                              )
                                            },
                                            expression: "fData.entity_name"
                                          }
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "registration.entity-name"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "md-error" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors["entity_siren"]
                                                    ? _vm.errors[
                                                        "entity_siren"
                                                      ][0]
                                                    : ""
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "md-field",
                                        {
                                          class: {
                                            "md-invalid": !!_vm.errors[
                                              "entity_name"
                                            ]
                                          }
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "registration.entity-name"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("md-input", {
                                            attrs: {
                                              name: "entity_name",
                                              disabled: _vm.submitting
                                                ? "disabled"
                                                : null,
                                              autofocus: ""
                                            },
                                            model: {
                                              value: _vm.fData.entity_name,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fData,
                                                  "entity_name",
                                                  $$v
                                                )
                                              },
                                              expression: "fData.entity_name"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "md-error" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors["entity_name"]
                                                    ? _vm.errors[
                                                        "entity_name"
                                                      ][0]
                                                    : ""
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEntityProfessional && _vm.showSirenInput
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden"
                                },
                                [
                                  _vm.fData.entity_country_id == 1
                                    ? _c(
                                        "md-autocomplete",
                                        {
                                          ref: "sirenAutocomplete",
                                          attrs: {
                                            "md-options": _vm.sirenResults,
                                            required: ""
                                          },
                                          on: {
                                            "md-changed": _vm.onSirenInput,
                                            "md-selected": _vm.onSirenSelected
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "md-autocomplete-item",
                                              fn: function(ref) {
                                                var item = ref.item
                                                return [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(item.siret) +
                                                      " - " +
                                                      _vm._s(
                                                        item.uniteLegale
                                                          .denominationUniteLegale
                                                      ) +
                                                      "\n                                "
                                                  )
                                                ]
                                              }
                                            }
                                          ]),
                                          model: {
                                            value: _vm.fData.entity_siren,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.fData,
                                                "entity_siren",
                                                $$v
                                              )
                                            },
                                            expression: "fData.entity_siren"
                                          }
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(_vm._s(_vm.getSirenText))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "md-error" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors["entity_siren"]
                                                    ? _vm.errors[
                                                        "entity_siren"
                                                      ][0]
                                                    : ""
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "md-field",
                                        {
                                          class: {
                                            "md-invalid": !!_vm.errors[
                                              "entity_siren"
                                            ]
                                          }
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(_vm._s(_vm.getSirenText))
                                          ]),
                                          _vm._v(" "),
                                          _c("md-input", {
                                            attrs: {
                                              type: "text",
                                              name: "entity_siren",
                                              disabled: _vm.submitting
                                                ? "disabled"
                                                : null
                                            },
                                            model: {
                                              value: _vm.fData.entity_siren,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fData,
                                                  "entity_siren",
                                                  $$v
                                                )
                                              },
                                              expression: "fData.entity_siren"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "md-error" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errors["entity_siren"]
                                                    ? _vm.errors[
                                                        "entity_siren"
                                                      ][0]
                                                    : ""
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEntityProfessional
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "form-row w-full shrink-0 desktop:w-1/2"
                                },
                                [
                                  _c(
                                    "md-field",
                                    {
                                      class: {
                                        "md-invalid": !!_vm.errors[
                                          "intracommunity_vat_number"
                                        ]
                                      }
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "registration.intracommunity-vat-number"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: {
                                          name: "intracommunity_vat_number",
                                          disabled: _vm.submitting
                                            ? "disabled"
                                            : null
                                        },
                                        model: {
                                          value:
                                            _vm.fData.intracommunity_vat_number,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.fData,
                                              "intracommunity_vat_number",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "fData.intracommunity_vat_number"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "md-error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors[
                                              "intracommunity_vat_number"
                                            ]
                                              ? _vm.errors[
                                                  "intracommunity_vat_number"
                                                ][0]
                                              : ""
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row w-full shrink-0 overflow-x-hidden",
                              class: {
                                "desktop:w-1/2": _vm.isEntityProfessional
                              }
                            },
                            [
                              _c(
                                "md-field",
                                {
                                  class: {
                                    "md-invalid": !!_vm.errors["entity_address"]
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("registration.entity-address")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "entity_address",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null
                                    },
                                    model: {
                                      value: _vm.fData.entity_address,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.fData,
                                          "entity_address",
                                          $$v
                                        )
                                      },
                                      expression: "fData.entity_address"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors["entity_address"]
                                          ? _vm.errors["entity_address"][0]
                                          : ""
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row w-full shrink-0 overflow-x-hidden",
                              class: {
                                "desktop:w-1/2": _vm.isEntityProfessional
                              }
                            },
                            [
                              _c(
                                "md-field",
                                {
                                  class: {
                                    "md-invalid": !!_vm.errors[
                                      "entity_postcode"
                                    ]
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("registration.entity-postcode")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "entity_postcode",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null,
                                      autocomplete: "shipping postal-code"
                                    },
                                    model: {
                                      value: _vm.fData.entity_postcode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.fData,
                                          "entity_postcode",
                                          $$v
                                        )
                                      },
                                      expression: "fData.entity_postcode"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors["entity_postcode"]
                                          ? _vm.errors["entity_postcode"][0]
                                          : ""
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row w-full shrink-0 overflow-x-hidden",
                              class: {
                                "desktop:w-1/2": _vm.isEntityProfessional
                              }
                            },
                            [
                              _c(
                                "md-field",
                                {
                                  class: {
                                    "md-invalid": !!_vm.errors["entity_city"]
                                  }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("registration.entity-city"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    attrs: {
                                      name: "entity_city",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null
                                    },
                                    model: {
                                      value: _vm.fData.entity_city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fData, "entity_city", $$v)
                                      },
                                      expression: "fData.entity_city"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors["entity_city"]
                                          ? _vm.errors["entity_city"][0]
                                          : ""
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-row w-full shrink-0 overflow-x-hidden",
                              class: {
                                "desktop:w-1/2": _vm.isEntityProfessional
                              }
                            },
                            [
                              _vm.fData.entity_country_id
                                ? _c("CountrySelector", {
                                    attrs: {
                                      "field-class": {
                                        "md-invalid": !!_vm.errors[
                                          "entity_country_id"
                                        ]
                                      },
                                      errors: _vm.errors["entity_country_id"],
                                      name: "entity_country_id",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null,
                                      model: _vm.fData.entity_country_id,
                                      "country-id": parseInt(
                                        _vm.fData.entity_country_id
                                      )
                                    },
                                    on: {
                                      "on-change": function(value) {
                                        return (_vm.fData.entity_country_id = value)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.isEntityProfessional
                            ? [
                                _c(
                                  "md-datepicker",
                                  {
                                    attrs: {
                                      name: "user_birthdate",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null,
                                      "md-model-type": String
                                    },
                                    model: {
                                      value: _vm.fData.user_birthdate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.fData,
                                          "user_birthdate",
                                          $$v
                                        )
                                      },
                                      expression: "fData.user_birthdate"
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("contract.user-birthdate")
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors["user_birthdate"]
                                        ? _vm.errors["user_birthdate"][0]
                                        : ""
                                    )
                                  )
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEntityProfessional
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden"
                                },
                                [
                                  _c(
                                    "md-field",
                                    {
                                      class: {
                                        "md-invalid": !!_vm.errors[
                                          "accounting_email"
                                        ]
                                      }
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "registration.accounting-email"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: {
                                          name: "accounting_email",
                                          disabled: _vm.submitting
                                            ? "disabled"
                                            : null,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.fData.accounting_email,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.fData,
                                              "accounting_email",
                                              $$v
                                            )
                                          },
                                          expression: "fData.accounting_email"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "md-error" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errors["accounting_email"]
                                              ? _vm.errors[
                                                  "accounting_email"
                                                ][0]
                                              : ""
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isEntityProfessional
                    ? _c("md-card-content", { staticClass: "col" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-lg font-bold text-primary-dark-500"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("contract.legal-representative")
                                ) +
                                "\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-col desktop:flex-row flex-wrap"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden"
                              },
                              [
                                _c(
                                  "md-field",
                                  {
                                    class: {
                                      "md-invalid": !!_vm.errors[
                                        "legal_representative_firstname"
                                      ]
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "contract.legal-representative-firstname"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      attrs: {
                                        type: "text",
                                        name: "legal_representative_firstname",
                                        disabled: _vm.submitting
                                          ? "disabled"
                                          : null
                                      },
                                      model: {
                                        value:
                                          _vm.fData
                                            .legal_representative_firstname,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fData,
                                            "legal_representative_firstname",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "fData.legal_representative_firstname"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "md-error" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors[
                                            "legal_representative_firstname"
                                          ]
                                            ? _vm.errors[
                                                "legal_representative_firstname"
                                              ][0]
                                            : ""
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden"
                              },
                              [
                                _c(
                                  "md-field",
                                  {
                                    class: {
                                      "md-invalid": !!_vm.errors[
                                        "legal_representative_lastname"
                                      ]
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "contract.legal-representative-lastname"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      attrs: {
                                        type: "text",
                                        name: "legal_representative_lastname",
                                        disabled: _vm.submitting
                                          ? "disabled"
                                          : null
                                      },
                                      model: {
                                        value:
                                          _vm.fData
                                            .legal_representative_lastname,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fData,
                                            "legal_representative_lastname",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "fData.legal_representative_lastname"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "md-error" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors[
                                            "legal_representative_lastname"
                                          ]
                                            ? _vm.errors[
                                                "legal_representative_lastname"
                                              ][0]
                                            : ""
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden"
                              },
                              [
                                _c(
                                  "md-datepicker",
                                  {
                                    attrs: {
                                      name: "legal_representative_birthdate",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null,
                                      "md-model-type": String
                                    },
                                    model: {
                                      value:
                                        _vm.fData
                                          .legal_representative_birthdate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.fData,
                                          "legal_representative_birthdate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "fData.legal_representative_birthdate"
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "contract.legal-representative-birthdate"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors[
                                        "legal_representative_birthdate"
                                      ]
                                        ? _vm.errors[
                                            "legal_representative_birthdate"
                                          ][0]
                                        : ""
                                    )
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden"
                              },
                              [
                                _c("CountrySelector", {
                                  attrs: {
                                    "field-class": {
                                      "md-invalid": !!_vm.errors[
                                        "legal_representative_country_id"
                                      ]
                                    },
                                    errors:
                                      _vm.errors[
                                        "legal_representative_country_id"
                                      ],
                                    name: "legal_representative_country_id",
                                    disabled: _vm.submitting
                                      ? "disabled"
                                      : null,
                                    model:
                                      _vm.fData.legal_representative_country_id,
                                    "country-id": parseInt(
                                      _vm.fData.legal_representative_country_id
                                    ),
                                    label: _vm.$t(
                                      "contract.legal-representative-country"
                                    )
                                  },
                                  on: {
                                    "on-change": function(value) {
                                      return (_vm.fData.legal_representative_country_id = value)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-row w-full desktop:w-1/2 shrink-0 overflow-x-hidden"
                              },
                              [
                                _c("CountrySelector", {
                                  attrs: {
                                    "field-class": {
                                      "md-invalid": !!_vm.errors[
                                        "legal_representative_birth_country_id"
                                      ]
                                    },
                                    errors:
                                      _vm.errors[
                                        "legal_representative_birth_country_id"
                                      ],
                                    name:
                                      "legal_representative_birth_country_id",
                                    disabled: _vm.submitting
                                      ? "disabled"
                                      : null,
                                    model:
                                      _vm.fData
                                        .legal_representative_birth_country_id,
                                    "country-id": parseInt(
                                      _vm.fData
                                        .legal_representative_birth_country_id
                                    ),
                                    label: _vm.$t(
                                      "contract.legal-representative-birth-country"
                                    )
                                  },
                                  on: {
                                    "on-change": function(value) {
                                      return (_vm.fData.legal_representative_birth_country_id = value)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !!_vm.price
            ? _c(
                "div",
                {
                  staticClass:
                    "border border-primary-500 rounded-md shadow-md p-6",
                  staticStyle: { "max-width": "600px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "contract-price-info" },
                    [
                      _c("div", { staticClass: "contract-price-name" }, [
                        _c("strong", [_vm._v(_vm._s(_vm.price.name))]),
                        _vm._v(" "),
                        !!_vm.fData.promoCode && _vm.fData.promoCode.free_months
                          ? _c("span", { staticClass: "contract-price-free" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "contract.free-months",
                                      {
                                        count: _vm.fData.promoCode.free_months
                                      },
                                      _vm.fData.promoCode.free_months
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex justify-end" }, [
                        _c("div", { staticClass: "contract-price-amount" }, [
                          _vm.fData.promoCode &&
                          (!!_vm.fData.promoCode.price ||
                            !!_vm.fData.promoCode.percentage)
                            ? _c("div", { staticClass: "promoPrice" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.getPricePromoPrice) +
                                    "\n                        "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getPrice) +
                              " *\n                    "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "contract-price-promo-code" }, [
                        _c("div", { staticClass: "text" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("contract.promo-code")) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        !_vm.fData.promoCode
                          ? _c("div", { staticClass: "input" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.promoCodeInput,
                                    expression: "promoCodeInput"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: { value: _vm.promoCodeInput },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.promoCodeInput = $event.target.value
                                  }
                                }
                              })
                            ])
                          : _c("div", { staticClass: "input valid" }, [
                              _c("span", [_vm._v(_vm._s(_vm.promoCodeInput))]),
                              _vm._v(" "),
                              _c(
                                "i",
                                {
                                  staticClass:
                                    "md-icon md-icon-font md-theme-default"
                                },
                                [
                                  _vm._v(
                                    "\n                            check\n                        "
                                  )
                                ]
                              )
                            ]),
                        _vm._v(" "),
                        !_vm.fData.promoCode
                          ? _c("div", { staticClass: "button" }, [
                              _c(
                                "button",
                                {
                                  attrs: {
                                    disabled:
                                      !_vm.promoCodeInput ||
                                      _vm.promoCodeInput.length == 0
                                  },
                                  on: { click: _vm.checkPromoCode }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("contract.apply")) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      !!_vm.errors["promoCode"]
                        ? _c("span", { staticClass: "md-error text-right" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("contract.invalid-promo-code")) +
                                " \n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "contract-price-promo-code mt-2" },
                        [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("contract.sponsor-code")) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.fData.sponsor
                            ? _c("div", { staticClass: "input" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.sponsorInput,
                                      expression: "sponsorInput"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    name: "sponsor",
                                    disabled: _vm.submitting ? "disabled" : null
                                  },
                                  domProps: { value: _vm.sponsorInput },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.sponsorInput = $event.target.value
                                    }
                                  }
                                })
                              ])
                            : _c("div", { staticClass: "input valid" }, [
                                _c("span", [_vm._v(_vm._s(_vm.fData.sponsor))]),
                                _vm._v(" "),
                                _c(
                                  "i",
                                  {
                                    staticClass:
                                      "md-icon md-icon-font md-theme-default"
                                  },
                                  [
                                    _vm._v(
                                      "\n                            check\n                        "
                                    )
                                  ]
                                )
                              ]),
                          _vm._v(" "),
                          !_vm.fData.sponsor
                            ? _c("div", { staticClass: "button" }, [
                                _c(
                                  "button",
                                  {
                                    attrs: {
                                      disabled:
                                        !_vm.sponsorInput ||
                                        _vm.sponsorInput.length == 0
                                    },
                                    on: { click: _vm.checkSponsor }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("contract.apply")) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      !!_vm.errors["sponsor"]
                        ? _c("span", { staticClass: "md-error text-right" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t("contract.invalid-sponsor-code")
                                ) +
                                " \n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-xs my-4" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t(
                                "contract.recurrence-footnote" +
                                  (_vm.isEntityProfessional
                                    ? ""
                                    : "-individual"),
                                {
                                  months: _vm.periodDurationIncludePromo,
                                  recurringPrice: _vm.isEntityProfessional
                                    ? _vm.price.recurring_price_ht
                                    : _vm.price.recurring_price_ttc
                                }
                              )
                            ) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-lg font-bold text-primary-dark-500 mt-10"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("contract.payment")) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row" },
                        [
                          _c("CountrySelector", {
                            attrs: {
                              "field-class": {
                                "md-invalid": !!_vm.errors["bank_country_id"]
                              },
                              errors: _vm.errors["bank_country_id"],
                              name: "bank_country_id",
                              disabled: _vm.submitting ? "disabled" : null,
                              model: _vm.fData.bank_country_id,
                              "country-id": parseInt(_vm.fData.bank_country_id),
                              label: _vm.$t("contract.bank-country")
                            },
                            on: {
                              "on-change": function(value) {
                                return (_vm.fData.bank_country_id = value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showGoCardlessPayment
                        ? [
                            _c(
                              "div",
                              { staticClass: "text-primary-dark-500 my-4" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$t("contract.payment-info")) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            !!_vm.selectedBankCountry
                              ? [
                                  _vm.selectedBankCountry.isoCode != "GB"
                                    ? _c(
                                        "div",
                                        { staticClass: "form-row" },
                                        [
                                          _c(
                                            "md-field",
                                            {
                                              staticClass: "iban",
                                              class: {
                                                "md-invalid": !!_vm.errors[
                                                  "entity_iban"
                                                ]
                                              }
                                            },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("contract.iban")
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("md-input", {
                                                directives: [
                                                  {
                                                    name: "mask",
                                                    rawName: "v-mask",
                                                    value:
                                                      "XXXX XXXX XXXX XXXX XXXX XXXX XXX",
                                                    expression:
                                                      "'XXXX XXXX XXXX XXXX XXXX XXXX XXX'"
                                                  }
                                                ],
                                                attrs: {
                                                  name: "entity_iban",
                                                  disabled: _vm.submitting
                                                    ? "disabled"
                                                    : null
                                                },
                                                model: {
                                                  value: _vm.fData.entity_iban,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.fData,
                                                      "entity_iban",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "fData.entity_iban"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "md-error" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.errors["entity_iban"]
                                                        ? _vm.errors[
                                                            "entity_iban"
                                                          ][0]
                                                        : ""
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : [
                                        _c(
                                          "div",
                                          { staticClass: "form-row" },
                                          [
                                            _c(
                                              "md-field",
                                              {
                                                staticClass: "branch_code",
                                                class: {
                                                  "md-invalid": !!_vm.errors[
                                                    "entity_branch_code"
                                                  ]
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "contract.branch-code"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("md-input", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: "XXXXXX",
                                                      expression: "'XXXXXX'"
                                                    }
                                                  ],
                                                  attrs: {
                                                    name: "entity_branch_code",
                                                    disabled: _vm.submitting
                                                      ? "disabled"
                                                      : null
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.fData
                                                        .entity_branch_code,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.fData,
                                                        "entity_branch_code",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "fData.entity_branch_code"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "md-error" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors[
                                                          "entity_branch_code"
                                                        ]
                                                          ? _vm.errors[
                                                              "entity_branch_code"
                                                            ][0]
                                                          : ""
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-row" },
                                          [
                                            _c(
                                              "md-field",
                                              {
                                                staticClass: "account_number",
                                                class: {
                                                  "md-invalid": !!_vm.errors[
                                                    "entity_account_number"
                                                  ]
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "contract.account-number"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("md-input", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: "XXXXXXXX",
                                                      expression: "'XXXXXXXX'"
                                                    }
                                                  ],
                                                  attrs: {
                                                    name:
                                                      "entity_account_number",
                                                    disabled: _vm.submitting
                                                      ? "disabled"
                                                      : null
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.fData
                                                        .entity_account_number,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.fData,
                                                        "entity_account_number",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "fData.entity_account_number"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "md-error" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.errors[
                                                          "entity_account_number"
                                                        ]
                                                          ? _vm.errors[
                                                              "entity_account_number"
                                                            ][0]
                                                          : ""
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-row" },
                              [
                                _c(
                                  "md-field",
                                  {
                                    staticClass: "account_holder_name",
                                    class: {
                                      "md-invalid": !!_vm.errors[
                                        "account_holder_name"
                                      ]
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("contract.account-holder-name")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      attrs: {
                                        name: "account_holder_name",
                                        disabled: _vm.submitting
                                          ? "disabled"
                                          : null
                                      },
                                      model: {
                                        value: _vm.fData.account_holder_name,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fData,
                                            "account_holder_name",
                                            $$v
                                          )
                                        },
                                        expression: "fData.account_holder_name"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "md-error" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors["account_holder_name"]
                                            ? _vm.errors[
                                                "account_holder_name"
                                              ][0]
                                            : ""
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStripePayment
                        ? _c("div", { staticClass: "my-4" }, [
                            _c(
                              "p",
                              { staticClass: "text-primary-dark-500 my-4" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("contract.card-payment-info"))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              attrs: { id: "link-authentication-element" }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              ref: "paymentElement",
                              attrs: { id: "payment-element" }
                            }),
                            _vm._v(" "),
                            !!_vm.stripeCardError
                              ? _c("span", { staticClass: "md-error" }, [
                                  _vm._v(_vm._s(_vm.stripeCardError))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !!_vm.stripeTrialPrice
                              ? _c(
                                  "div",
                                  { staticClass: "my-4 text-primary-dark-500" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$t("contract.total-price", {
                                            price: _vm.$pu(_vm.stripeTrialPrice)
                                          })
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "flex space-x-2 mt-2 items-start" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.acceptTos,
                                expression: "acceptTos"
                              }
                            ],
                            staticClass: "mt-1",
                            attrs: { type: "checkbox", dusk: "acceptTos" },
                            domProps: {
                              checked: Array.isArray(_vm.acceptTos)
                                ? _vm._i(_vm.acceptTos, null) > -1
                                : _vm.acceptTos
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.acceptTos,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.acceptTos = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.acceptTos = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.acceptTos = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("contract.tos"))
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.isEntityProfessional
                        ? _c("label", { staticClass: "flex space-x-2 mt-2" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.acceptPayment,
                                  expression: "acceptPayment"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.acceptPayment)
                                  ? _vm._i(_vm.acceptPayment, null) > -1
                                  : _vm.acceptPayment
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.acceptPayment,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.acceptPayment = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.acceptPayment = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.acceptPayment = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("contract.accept-payment")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ibanError
                        ? _c(
                            "div",
                            { staticClass: "text-red-500 font-semibold mt-2" },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.ibanError) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex justify-end" },
        [
          _c("submit-button", {
            staticClass: "px-4 mb-4",
            attrs: {
              type: "submit",
              submitting: _vm.submitting,
              label: _vm.$t("contract.validate-contract"),
              dusk: "submit-profile-button",
              disabled: !_vm.canSubmit
            },
            on: {
              click: function($event) {
                _vm.onSubmit()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.showSmsDialog },
          on: {
            "update:mdActive": function($event) {
              _vm.showSmsDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex flex-col justify-center h-screen items-center desktop:h-auto"
            },
            [
              !_vm.submitting
                ? _c("div", { staticClass: "sms-dialog" }, [
                    _vm.showPhoneInput
                      ? _c(
                          "div",
                          { staticClass: "form-row" },
                          [
                            _c("phone-field", {
                              ref: "phoneInput",
                              attrs: {
                                name: "phone",
                                errors: _vm.errors["phone"],
                                label: _vm.$t("contract.phone"),
                                "country-id": _vm.countryId,
                                "mobile-only": "",
                                disabled: _vm.submitting ? "disabled" : null
                              },
                              model: {
                                value: _vm.fData.phone,
                                callback: function($$v) {
                                  _vm.$set(_vm.fData, "phone", $$v)
                                },
                                expression: "fData.phone"
                              }
                            }),
                            _vm._v(" "),
                            _c("submit-button", {
                              staticClass: "registration-standalone-button",
                              attrs: {
                                type: "submit",
                                submitting: _vm.sendingCode,
                                label: "Recevoir le code par SMS",
                                disabled: !_vm.isValidMobilePhone
                              },
                              on: { click: _vm.sendCode }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.showPhoneInput
                      ? _c("div", { staticClass: "form-row" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("contract.code-sent-helper", {
                                  phone: _vm.fData.phone
                                })
                              ) +
                              "\n                    "
                          ),
                          _c(
                            "form",
                            [
                              _c(
                                "md-field",
                                {
                                  class: {
                                    "md-invalid": !!_vm.errors["code"],
                                    "code-field": true
                                  }
                                },
                                [
                                  _c("md-input", {
                                    staticStyle: { display: "none" },
                                    attrs: {
                                      type: "text",
                                      name: "code",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null
                                    },
                                    model: {
                                      value: _vm.fData.code,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fData, "code", $$v)
                                      },
                                      expression: "fData.code"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      ref: "smsCodeInputs",
                                      staticClass: "SMS__Code"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.SMSCode.input1,
                                            expression: "SMSCode.input1"
                                          }
                                        ],
                                        ref: "firstInput",
                                        staticClass: "SMS__Code__Input",
                                        attrs: {
                                          type: "number",
                                          inputmode: "tel",
                                          id: "smsCodeInput0"
                                        },
                                        domProps: { value: _vm.SMSCode.input1 },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.SMSCode,
                                                "input1",
                                                $event.target.value
                                              )
                                            },
                                            _vm.focusNextSMSCodeInput
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.SMSCode.input2,
                                            expression: "SMSCode.input2"
                                          }
                                        ],
                                        staticClass: "SMS__Code__Input",
                                        attrs: {
                                          type: "number",
                                          inputmode: "tel",
                                          id: "smsCodeInput1"
                                        },
                                        domProps: { value: _vm.SMSCode.input2 },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.SMSCode,
                                                "input2",
                                                $event.target.value
                                              )
                                            },
                                            _vm.focusNextSMSCodeInput
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.SMSCode.input3,
                                            expression: "SMSCode.input3"
                                          }
                                        ],
                                        staticClass: "SMS__Code__Input",
                                        attrs: {
                                          type: "number",
                                          inputmode: "tel",
                                          id: "smsCodeInput2"
                                        },
                                        domProps: { value: _vm.SMSCode.input3 },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.SMSCode,
                                                "input3",
                                                $event.target.value
                                              )
                                            },
                                            _vm.focusNextSMSCodeInput
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.SMSCode.input4,
                                            expression: "SMSCode.input4"
                                          }
                                        ],
                                        staticClass: "SMS__Code__Input",
                                        attrs: {
                                          type: "number",
                                          inputmode: "tel",
                                          id: "smsCodeInput3"
                                        },
                                        domProps: { value: _vm.SMSCode.input4 },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.SMSCode,
                                                "input4",
                                                $event.target.value
                                              )
                                            },
                                            _vm.focusNextSMSCodeInput
                                          ]
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "md-helper-text" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pointer",
                                          attrs: { role: "button" },
                                          on: {
                                            click: function($event) {
                                              _vm.active = true
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "contract.resend-code-confirm-title"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.errors["code"]
                                            ? _vm.errors["code"][0]
                                            : ""
                                        ) +
                                        " \n                                "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "pointer",
                                        attrs: { role: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.active = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "contract.resend-code-confirm-title"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                : _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "flex flex-col justify-center items-center"
                      },
                      [
                        _c("md-spinner"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-primary-dark-500 mt-4" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("contract.signing")) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("md-dialog-confirm", {
        attrs: {
          "md-active": _vm.active,
          "md-title": _vm.$t("contract.resend-code-confirm-title"),
          "md-content": _vm.$t("contract.resend-code-confirm-desc", {
            number: _vm.fData.phone
          }),
          "md-confirm-text": _vm.$t("contract.resend-code-confirm-title"),
          "md-cancel-text": _vm.$t("contract.cancel")
        },
        on: {
          "update:mdActive": function($event) {
            _vm.active = $event
          },
          "md-confirm": _vm.onConfirm
        }
      }),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.showPaymentConfirmation },
          on: {
            "update:mdActive": function($event) {
              _vm.showPaymentConfirmation = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "p-8 text-primary-dark-500 payment-confirmation-dialog overflow-y-auto pt-20 desktop:pt-8"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex justify-between items-center mb-8 space-x-8"
                },
                [
                  _c("h3", { staticClass: "font-bold text-lg" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t(
                            "contract.sepa-mandate" +
                              (_vm.isEntityProfessional ? "" : "-individual")
                          )
                        ) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "w-24",
                    attrs: { src: "/imgs/icons/sepa.svg" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "uppercase font-bold" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("contract.debit-request")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "my-4" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("contract.debit-request-validity")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex desktop:space-x-4 flex-col desktop:flex-row"
                },
                [
                  _c(
                    "div",
                    { staticClass: "w-full desktop:w-1/2 border p-4" },
                    [
                      _c("div", { staticClass: "font-bold mb-4" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("contract.account-to-debit")) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col desktop:flex-row justify-start my-2 whitespace-nowrap shrink-0 desktop:items-center"
                        },
                        [
                          _c("div", { staticClass: "font-bold mr-4" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("contract.bank-country")) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          !!_vm.selectedBankCountry
                            ? _c("div", { staticClass: "whitespace-normal" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.selectedBankCountry.name) +
                                    "\n                        "
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col desktop:flex-row justify-start my-2 whitespace-nowrap shrink-0 desktop:items-center"
                        },
                        [
                          _c("div", { staticClass: "font-bold mr-4" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("contract.iban")) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "whitespace-normal" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.fData.entity_iban) +
                                "\n                        "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col desktop:flex-row justify-start my-2 whitespace-nowrap shrink-0 desktop:items-center"
                        },
                        [
                          _c("div", { staticClass: "font-bold mr-4" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("contract.account-holder-name")) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "whitespace-normal" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.fData.account_holder_name) +
                                "\n                        "
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-full desktop:w-1/2 border p-4 mt-4 desktop:mt-0"
                    },
                    [
                      _c("div", { staticClass: "font-bold mb-4" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("contract.creditor")) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col desktop:flex-row justify-start my-2 whitespace-nowrap shrink-0 desktop:items-center"
                        },
                        [
                          _c("div", { staticClass: "font-bold mr-4" }, [
                            _vm._v(
                              "\n                            OpenFly\n                        "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col desktop:flex-row justify-start my-2 whitespace-nowrap shrink-0 desktop:items-center"
                        },
                        [
                          _c("div", { staticClass: "font-bold mr-4" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("contract.sepa-identifier")) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "whitespace-normal" }, [
                            _vm._v(
                              "\n                            FR26ZZZ8231EE\n                        "
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "text-xs mt-4" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "contract.signature-info" +
                        (_vm.isEntityProfessional ? "" : "-individual")
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "font-bold mt-8 mb-4" }, [
                _vm._v(_vm._s(_vm.$t("contract.first-fee")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex justify-between items-center flex-col desktop:flex-row"
                },
                [
                  _c("div", {
                    ref: "paymentConfirmationCompliance",
                    attrs: { id: "paymentConfirmationCompliance" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-end items-center mt-4 desktop:mt-0"
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "!text-gray-700 !text-xs cursor-pointer !underline mr-4",
                          on: {
                            click: function($event) {
                              _vm.showPaymentConfirmation = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                      ),
                      _vm._v(" "),
                      _c("submit-button", {
                        staticClass: "!text-white",
                        attrs: {
                          label: _vm.$t("contract.confirm-payment"),
                          dusk: "confirmPaymentButton",
                          submitting: _vm.submittingPayment
                        },
                        on: { click: _vm.confirmPayment }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: {
            "md-active": _vm.showSelectInstitutionModal,
            "md-click-outside-to-close": false,
            "md-close-on-esc": false
          },
          on: {
            "update:mdActive": function($event) {
              _vm.showSelectInstitutionModal = $event
            }
          }
        },
        [
          _c("div", { staticClass: "p-4 select-institution-modal" }, [
            _c("h3", { staticClass: "font-bold text-lg mb-4" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("contract.select-institution")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "md-field",
                  {
                    class: { "md-invalid": !!_vm.errors["bank_institution_id"] }
                  },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("contract.bank")) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "md-select",
                      {
                        attrs: { name: "bank_institution_id" },
                        model: {
                          value: _vm.fData.bank_institution_id,
                          callback: function($$v) {
                            _vm.$set(_vm.fData, "bank_institution_id", $$v)
                          },
                          expression: "fData.bank_institution_id"
                        }
                      },
                      _vm._l(_vm.bankInstitutions, function(institution) {
                        return _c(
                          "md-option",
                          {
                            key: institution.id,
                            attrs: { value: institution.id }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(institution.name) +
                                "\n                        "
                            )
                          ]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "md-error" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.errors["bank_institution_id"] &&
                              _vm.errors["bank_institution_id"].length
                              ? _vm.errors["bank_institution_id"][0]
                              : ""
                          ) +
                          "\n                    "
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-end items-center" },
              [
                _c(
                  "a",
                  {
                    staticClass: "!text-gray-700 !text-xs cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.showSelectInstitutionModal = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                ),
                _vm._v(" "),
                _c("submit-button", {
                  staticClass: "!text-white",
                  attrs: {
                    label: _vm.$t("contract.confirm-payment"),
                    dusk: "setInstitutionButton"
                  },
                  on: { click: _vm.setInstitution }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e079c302", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e079c302","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ValidateContract.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e079c302","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ValidateContract.vue
// module chunks = 1 2 3